import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/sharp-solid-svg-icons/faPrint';
import classnames from 'classnames';

import { DecoratedIcon } from 'ui-components/components/decorated-icon';

import styles from '../app-header.module.less';

type PrintQueueIconProps = {
  alertCount?: number;
};

export const PrintQueueIcon = (props: PrintQueueIconProps) => (
  <DecoratedIcon decoration={props.alertCount} decorationClassName='custom-decoration-class' showDecoration {...props}>
    <FontAwesomeIcon className={classnames(styles['menu-item-icon'], styles['print-queue-icon'])} icon={faPrint} />
  </DecoratedIcon>
);
